<template>
  <v-card>
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold "
        >Outbound Packages
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          icon
          @click="showPackageCreateDialog = true"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Create package</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="refresh()">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-title>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-text-field
            color="secondary"
            label="Search"
            v-model="searchItem"
            xs5
          >
          </v-text-field>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="refresh">
          <v-icon>search</v-icon>
        </v-btn>
        <span>Search</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="searchItem = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="tableItems"
      item-key="hexId"
      :loading="packageLoader"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      :rows-per-page-items="headerPageItems"
    >
      <v-progress-linear slot="progress" color="accent" indeterminate />
      <template slot="items" slot-scope="props">
        <tr>
          <td @click="props.expanded = !props.expanded" class="text-xs-left">
            <div class="body-1 font-weight-bold" v-if="props.item.hexId">
              {{ props.item.hexId }}
            </div>
            <div class="caption">
              {{
                changeCase(props.item.packageType) +
                  ' | ' +
                  props.item.packageManifestModel.packageId
              }}
            </div>
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left">
            <div class="body-1 font-weight-bold">
              {{ props.item.description }}
            </div>
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left">
            <div class="body-1 font-weight-bold" v-if="props.item.createdAt">
              {{ props.item.createdAtLocal }}
            </div>
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left">
            <div class="body-1 font-weight-bold" v-if="props.item.createdBy">
              {{ props.item.createdByByLocal || props.item.createdBy }}
            </div>
          </td>
          <td class="align-center justify-center fill-height">
            <v-btn
              v-if="can('PUSH_OUTBOUND_PACKAGE')"
              :key="props.item.hexId + 'retrigger'"
              :loading="props.item.checkLoader"
              @click="confirmPushToTulip(props.item)"
              flat
              icon
            >
              <v-icon medium>
                local_shipping
              </v-icon>
            </v-btn>
          </td>
          <td class="align-center justify-center fill-height">
            <v-btn
              v-if="can('DOWNLOAD_OUTBOUND_PACKAGE')"
              :key="props.item.hexId + 'retrigger'"
              :loading="props.item.downloadLoader"
              @click="downloadPackage(props.item)"
              flat
              icon
            >
              <v-icon medium>
                file_download
              </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <package-detail
          :a-package="props.item"
          :check-result="props.item.checkResult"
          :check-loader="props.item.checkLoader"
          :inbound-packages="false"
        ></package-detail>
      </template>
    </v-data-table>
    <v-dialog v-model="showPackageCreateDialog" fullscreen>
      <v-card>
        <v-toolbar dense card class="elevation-2">
          <v-toolbar-title class="body-2 beez-bold ">
            Create a new Package
          </v-toolbar-title>
          <v-layout justify-end align-center>
            <v-btn flat icon @click.stop="showPackageCreateDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-toolbar>
        <v-card-text>
          <create-package @packageAdded="packagedAdded"></create-package>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showPushToTulipDialog" max-width="60%">
      <v-card>
        <v-toolbar dense card class="elevation-2">
          <v-toolbar-title class="body-2 beez-bold ">
            Push to a destination Tulip system
          </v-toolbar-title>
          <v-layout justify-end align-center>
            <v-btn flat icon @click.stop="showPushToTulipDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-toolbar>
        <v-card-text>
          <v-card
            :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
            style="border-radius: 5px"
          >
            <v-toolbar flat dense>
              <v-toolbar-title class="body-2 beez-bold "
                >Direct Tulip Push</v-toolbar-title
              >
            </v-toolbar>
            <v-card-text>
              <v-form ref="tulipForm" v-model="valid">
                <v-container>
                  <v-layout row wrap justify-space-around align-center>
                    <v-flex xs12>
                      <v-text-field
                        v-model="beekeeperHostname"
                        :rules="hostNameRule"
                        label="Tulip Hostname"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="username"
                        :rules="nameRule"
                        label="Tulip Username"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="password"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[passwordRules.required]"
                        :type="showPassword ? 'text' : 'password'"
                        name="input-10-1"
                        label="Tulip Password / PAT Token"
                        required
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              class="text-capitalize"
              :class="!$vuetify.dark ? 'secondary' : ''"
              :color="$vuetify.dark ? 'secondary' : ''"
              :outline="$vuetify.dark"
              @click="pushToTulip()"
              :loading="pushLoader"
              >Push to Tulip
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import PackageDetail from '@/components/package-management/PackageDetail'
import CreatePackage from '@/components/package-management/CreatePackage'
import _ from 'lodash'

export default {
  name: 'OutBoundPackage',
  components: {
    PackageDetail,
    CreatePackage
  },
  data() {
    return {
      searchItem: '',
      selectedPackage: null,
      valid: false,
      beekeeperHostname: '',
      username: '',
      password: '',
      showPassword: false,
      passwordRules: {
        required: value => !!value || 'Required.'
      },
      nameRule: [v => !!v || 'User name is required'],
      hostNameRule: [
        v => !!v || 'Tulip Host name is required',
        v => this.isURL(v) || 'Tulip Host name is invalid'
      ],
      showPushToTulipDialog: false,
      pushLoader: false,
      showPackageCreateDialog: false,
      hiveLoader: false,
      tableItems: [],
      packageLoader: false,
      currentPage: 0,
      sortBy: '',
      rowsPerPage: 0,
      descending: false,
      pagination: {
        sortBy: 'createdAt',
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        page: 1
      },
      headerPageItems: [5, 10, 25],
      search: '',
      headers: [
        {
          text: 'Package ID / Unique reference number',
          align: 'left',
          value: 'hexId',
          sortable: false
        },
        { text: 'Package Description', value: 'description' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Created By', value: 'createdBy' },
        {
          text: 'Push to Tulip',
          align: 'center',
          value: 'check',
          sortable: false
        },
        {
          text: 'Download Package',
          align: 'center',
          value: 'retrigger',
          sortable: false
        }
      ],
      headersTemplates: [
        { text: 'Source Id', value: 'sourceId' },
        { text: 'Agent Type', value: 'agentType' },
        { text: 'Automation Agent', value: 'agentId' }
      ]
    }
  },
  computed: {
    ...mapState({
      totalPackages: state => state.packages.outboundPackageCount,
      packages: state => state.packages.outboundPackages,
      honeyUsers: state => state.honeyUsers.honeyUsers,
      hives: state => state.hives.hives
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  mounted() {
    this.pagination.totalItems = this.totalPackages
  },
  watch: {
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.currentPage ||
            this.pagination.rowsPerPage !== this.rowsPerPage ||
            this.pagination.sortBy !== this.sortBy ||
            this.pagination.descending !== this.descending
          ) {
            this.currentPage = this.pagination.page
            this.rowsPerPage = this.pagination.rowsPerPage
            this.sortBy = this.pagination.sortBy
            this.descending = this.pagination.descending
            this.refresh()
          }
        } catch (
          error
          // eslint-disable-next-line no-empty
        ) {}
      },
      deep: true
    },

    totalPackages() {
      this.pagination.totalItems = this.totalPackages
    },
    packages() {
      let packagesList = _.clone(this.packages)
      this.tableItems = packagesList.map(e => {
        try {
          e.createdByByLocal = this.honeyUsers.find(
            user => user.hexId === e.createdBy
          ).username
          e.downloadLoader = false
          // eslint-disable-next-line no-empty
        } catch (ex) {}
        return e
      })
    }
  },
  methods: {
    isURL(str) {
      let url

      try {
        url = new URL(str)
      } catch (_) {
        return false
      }

      return url.protocol === 'http:' || url.protocol === 'https:'
    },
    packagedAdded() {
      this.showPackageCreateDialog = false
      this.refresh()
    },
    setItemDownloadLoader(aPackage, flag) {
      this.tableItems = this.tableItems.map(item => {
        if (aPackage.hexId === item.hexId) {
          item.downloadLoader = flag
        }
        return item
      })
    },
    setItemPushLoader(aPackage, flag) {
      this.tableItems = this.tableItems.map(item => {
        if (aPackage.hexId === item.hexId) {
          item.pushLoader = flag
        }
        return item
      })
    },
    downloadPackage(item) {
      this.setItemDownloadLoader(item, true)
      let url = `/api/core/packages/${item.hexId}/download`
      window.open(url, '_self')
      this.setItemDownloadLoader(item, false)
    },
    confirmPushToTulip(item) {
      this.selectedPackage = item
      this.showPushToTulipDialog = true
    },
    async pushToTulip() {
      if (this.$refs.tulipForm.validate()) {
        this.setItemPushLoader(this.selectedPackage, true)
        this.pushLoader = true
        try {
          let data = {}
          data.id = this.selectedPackage.hexId
          data.body = {}
          data.body.beekeeperHostname = this.beekeeperHostname
          data.body.username = this.username
          data.body.password = this.password
          let response = await this.$store.dispatch('pushToRemoteTulip', data)
          if (response && response.body && response.body.hexId) {
            await this.$store.dispatch('directNotification', {
              type: 'success',
              message: 'Package pushed successfully',
              description: `Package with Id ${response.body.hexId} created successfully in the destination Tulip system`,
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          }
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to push Package to tulip',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
        this.setItemPushLoader(this.selectedPackage, false)
        this.showPushToTulipDialog = false
        this.pushLoader = false
      }
    },
    changeCase(str) {
      return _.startCase(_.lowerCase(str))
    },

    async refresh() {
      this.packageLoader = true
      let urlParams = ''
      urlParams = `page=${this.pagination.page}`
      if (this.pagination.rowsPerPage !== -1) {
        urlParams =
          urlParams +
          `&size=${this.pagination.rowsPerPage}&sort=${this.pagination.sortBy}${
            this.pagination.descending ? ',desc' : ''
          }`
      }
      if (this.searchItem !== '') {
        urlParams = urlParams + `&search=${this.searchItem}`
      }
      try {
        await this.$store.dispatch('fetchOutboundPackages', urlParams)
        await this.$store.dispatch('fetchOutboundPackagesCount')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in getting packages',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.packageLoader = false
    },

    async getHives() {
      this.hiveLoader = true
      try {
        await this.$store.dispatch('fetchHives')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Agent',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.hiveLoader = false
    }
  }
}
</script>

<style scoped></style>
